/** @flow */

import * as actions from "@modules/service/constants/actions";
import * as shiftPatternsReducers from "./reducers";
import initialState from "./state";
import type { ManagerSmsNotificationsState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: ManagerSmsNotificationsState = initialState,
  action: Object,
): ManagerSmsNotificationsState => {
  const act = {
    [actions.GetManagerSmsNotificationSettings]: shiftPatternsReducers.onGetManagerSmsSettings,
    [actions.GetManagerSmsNotificationSettingsSuccess]:
      shiftPatternsReducers.onGetManagerSmsSettingsSuccess,
    [actions.GetManagerSmsNotificationSettingsError]:
      shiftPatternsReducers.onGetManagerSmsSettingsError,
    [actions.GetManagerSmsNotificationsSmsRules]:
      shiftPatternsReducers.onGetManagerSmsNotificationsSmsRules,
    [actions.GetManagerSmsNotificationsSmsRulesSuccess]:
      shiftPatternsReducers.onGetManagerSmsNotificationsSmsRulesSuccess,
    [actions.GetManagerSmsNotificationsSmsRulesError]:
      shiftPatternsReducers.onGetManagerSmsNotificationsSmsRulesError,
    [actions.GetManagerSmsNotificationsPagerRules]:
      shiftPatternsReducers.onGetManagerSmsNotificationsPagerRules,
    [actions.GetManagerSmsNotificationsPagerRulesSuccess]:
      shiftPatternsReducers.onGetManagerSmsNotificationsPagerRulesSuccess,
    [actions.GetManagerSmsNotificationsPagerRulesError]:
      shiftPatternsReducers.onGetManagerSmsNotificationsPagerRulesError,
    [actions.SetManagerSmsNotificationCurrent]:
      shiftPatternsReducers.onSetManagerSmsNotificationCurrent,
    [actions.SetManagerSmsNotificationAssignments]:
      shiftPatternsReducers.onSetManagerSmsNotificationAssignments,
    [actions.GetManagerSmsNotificationsSmsAssignmentsSuccess]:
      shiftPatternsReducers.onSetManagerSmsNotificationAssignments,
    [actions.GetManagerSmsNotificationsPagerAssignmentsSuccess]:
      shiftPatternsReducers.onSetManagerSmsNotificationAssignments,
    [actions.SetShowAddManagerSmsNotificationModal]: shiftPatternsReducers.onSetShowAddModal,
    [actions.SetShowEditManagerSmsNotificationModal]: shiftPatternsReducers.onSetShowEditModal,
    [actions.SetShowDeleteManagerSmsNotificationModal]: shiftPatternsReducers.onSetShowDeleteModal,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
